import React, { useEffect, useRef, useState, memo } from "react";
import {Container,Pagination,Table,} from "react-bootstrap";

function TradingViewWidget() {
  const container = useRef(null);
  const [tradeAmount, setTradeAmount] = useState(""); // Empty input initially
  const [showModal, setShowModal] = useState(false);
  const [tradeType, setTradeType] = useState(""); // "Buy" or "Sell"
  const [tradeHistory, setTradeHistory] = useState([]);

  
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil(5 / 5); // Assuming 5 items in total for pagination example
  
  


  useEffect(() => {
    if (container.current) {
      container.current.innerHTML = "";
    }

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
      {
        "autosize": true,
        "symbol": "XAUUSD",
        "interval": "D",
        "timezone": "Etc/UTC",
        "theme": "dark",
        "style": "1",
        "locale": "en",
        "allow_symbol_change": true,
        "calendar": false,
        "support_host": "https://www.tradingview.com"
      }`;

    if (container.current) {
      container.current.appendChild(script);
    }
  }, []);

  const handleTrade = (type) => {
    if (!tradeAmount || parseFloat(tradeAmount) <= 0) {
      alert("Please enter a valid trade amount.");
      return;
    }
    setTradeType(type);
    setShowModal(true);
  };

  const confirmTrade = async () => {
    try {
      const response = await fetch("http://localhost:5000/api/trade", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: tradeType,
          amount: tradeAmount,
        }),
      });
  
      const result = await response.json();
      alert(result.message);
      setShowModal(false);
      setTradeAmount(""); // clear the input
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit trade.");
    }
  };
  

  useEffect(() => {
    document.title = "TradingView Widget | Bitstek Advisory";
    fetchTradeHistory(); // Fetch trade history on mount
  }, []);
  
  const fetchTradeHistory = async () => {
    try {
      const response = await fetch("http://localhost:5000/api/trades");
      const data = await response.json();
      setTradeHistory(data);
    } catch (error) {
      console.error("Failed to fetch trade history:", error);
    }
  };
  
  
  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div className="tradingview-widget-container" ref={container} style={{ width: "100%", minHeight: "500px" }}>
        <div className="tradingview-widget-container__widget" style={{ height: "100%", width: "100%" }}></div>
      </div>
  <br />
      {/* Trade Amount Input */}
                          
            
      {/* Buy & Sell Buttons with Amount */}
      <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
        <button onClick={() => handleTrade("Buy")} className="btn btn-success">Buy</button>
        {/* <span style={{ fontSize: "18px", fontWeight: "bold", color:'white'}}>${tradeAmount || "0.00"}</span> */}
        <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
        <input
          type="number"
          value={tradeAmount}
          onChange={(e) => setTradeAmount(e.target.value)}
          placeholder="Enter lot size"
          style={{ padding: "5px", fontSize: "16px", width: "150px", textAlign: "center", borderRadius: "5px", border: "1px solid #ccc", marginTop: "-10px" }}
        />
      </div>
        <button onClick={() => handleTrade("Sell")} className="btn btn-danger">Sell</button>
      </div>

      {/* Modal Popup */}
      {showModal && (
        <div style={{
          position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          backgroundColor: "white", padding: "20px", borderRadius: "10px", boxShadow: "0 0 10px rgba(0,0,0,0.2)"
        }}>
          <h3>{tradeType} Confirmation</h3>
          <p>Are you sure you want to {tradeType.toLowerCase()} for <strong>${tradeAmount}</strong>?</p>
          <p><small>Trading conditions apply. Please review before proceeding.</small></p>
          <div style={{ display: "flex", justifyContent: "space-around", marginTop: "10px" }}>
            <button onClick={confirmTrade} className="btn btn-success">Confirm</button>
            <button onClick={() => setShowModal(false)} className="btn btn-danger">Cancel</button>
          </div>
        </div>
      )}

             
       <Container className="mt-4 custom-container ">
              <h4 className="text-center text-primary"> History</h4>
              <Table striped bordered responsive className="text-center shadow-sm">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Date & Time</th>
                   
                  </tr>
                </thead>
                <tbody>
  {tradeHistory.length > 0 ? (
    tradeHistory.map((trade, index) => (
      <tr key={trade.id}>
        <td>{index + 1}</td>
        <td>{trade.type}</td>
        <td>${parseFloat(trade.amount).toFixed(2)}</td>
        <td>{new Date(trade.created_at).toLocaleString()}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4">No history available.</td>
    </tr>
  )}
</tbody>

              </Table>
      
              {/* Pagination Controls */}
              <div className="d-flex justify-content-center mt-3">
                <Pagination>
                  {[...Array(totalPages)].map((_, pageIndex) => (
                    <Pagination.Item
                      key={pageIndex}
                      active={currentPage === pageIndex + 1}
                      onClick={() => handlePageChange(pageIndex + 1)}
                    >
                      {pageIndex + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            </Container>
    </div>
  );
}

export default memo(TradingViewWidget);
